import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    TgAspectRatioModule,
    TgIconBasicWarningFramedModule,
    TgIconBinModule,
    TgRackModule,
    TgGridModule
} from '@trademe/tangram';

import { PhotoCardComponent } from './photo-card.component';

@NgModule({
    imports: [
        CommonModule,
        TgAspectRatioModule,
        TgIconBasicWarningFramedModule,
        TgIconBinModule,
        TgRackModule,
        TgGridModule
    ],
    declarations: [PhotoCardComponent],
    exports: [PhotoCardComponent]
})
export class PhotoCardModule {}
